import React from 'react';
import { FaThumbsUp } from 'react-icons/fa';
import styles from '../FeedbackPage.module.css';

const ThankYouCard = ({ handleGeneratorClick }) => (
    <div className={styles.thankYouCard}>
    <div className={styles.thankYouIcon}>
        <FaThumbsUp />
    </div>
    <h2>Thank You For Your Feedback!</h2>
    <p>Your insights are extremely valuable to us. We'll use your feedback to improve EcomBuddha and improve your experience.</p>
    <button 
        className={`${styles.btn} ${styles.btnPrimary}`}
        style={{maxWidth:'350px'}}
        onClick={() => handleGeneratorClick('/dashboard')}
    >
        Go Back To Homepage
    </button>
</div>
);

export default ThankYouCard;
